import { Input, Directive } from '@angular/core';

import { Observable } from 'rxjs';

import { Size } from '../btn.constants';

@Directive()
export abstract class BtnAction2Component
{
    @Input() btnText: string;
    @Input() btnWidth: number;
    @Input() disabled?: Observable<boolean>;
    @Input() size: Size = 'medium';
    @Input() cta: () => void;

    onClick ()
    {
        if (this.cta)
        {
            this.cta();
        }
    }

    getClassNames ()
    {
        return {
            [this.size]: true
        };
    }
}
